import defaultTheme from './themes/default.json';

// COLOUR SOURCE OF TRUTH (May 2026 redesign, Claude Design):
// `defaultTheme.coloursV2` holds the ONLY palette to use going forward
// (cascade-walked applied values from the V2 handoff, dark + light, global
// + per-scope overrides). Adoption is page-by-page — currently the Processes
// page only — so the legacy `schemes` block below is still wired in for
// every other surface. Do NOT blanket-swap `schemes` for `coloursV2`; migrate
// each consuming page deliberately. See `coloursV2._meta` in default.json.

export const colorsSource = defaultTheme.palettes;

export const lightThemeColors = defaultTheme.schemes.light;

export const darkThemeColors = defaultTheme.schemes.dark;

export const coloursV2 = defaultTheme.coloursV2;
